// AI-ASSISTED: generated with claude-code on 2026-08-28, reviewed by Yoann Hertienne
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useEntity } from '@backstage/plugin-catalog-react';
import { TileBoundary } from '../team-landing/TileBoundary';

// The service account (ADO *service connection* identity) that authenticates
// this component's Azure DevOps pipeline to its Bitbucket repository for source
// checkout/CI. Read-only display — the value is authored by a separate
// workstream (spec 002 / DPT-511). Plain text, no link-out and no copy control
// (FR-003); an account identifier, never a secret (FR-006).
const SERVICE_CONNECTION_ANNOTATION = 'dev.azure.com/service-connection-account';

const ServiceConnectionAccountCardBody = () => {
  const { entity } = useEntity();
  const account = entity.metadata.annotations?.[SERVICE_CONNECTION_ANNOTATION]?.trim();

  // Hide the tile when the annotation is absent, empty or whitespace-only
  // (spec FR-004) — the rollout is gradual, so most components lack it.
  if (!account) return null;

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6">Azure DevOps service connection</Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Service account linking this component's Azure DevOps pipeline to its
          Bitbucket repository.
        </Typography>
        <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
          {account}
        </Typography>
      </CardContent>
    </Card>
  );
};

export const ServiceConnectionAccountCard = () => (
  <TileBoundary tool="Service connection account">
    <ServiceConnectionAccountCardBody />
  </TileBoundary>
);
